import { ReactNode } from 'react';
import { StyledFooterRetailerInfo } from './FooterRetailer.styles';

interface FooterRetailerInfoProps {
  children: ReactNode;
}

const FooterRetailerInfo = ({ children }: FooterRetailerInfoProps) => {
  return <StyledFooterRetailerInfo>{children}</StyledFooterRetailerInfo>;
};

export default FooterRetailerInfo;
